import React, { useEffect, useRef, useState } from "react";
import { Box, Stack } from "@mui/material";
import { SegmentSubTitle, SegmentTitleEmoji } from "../SegmentSettings.styled";
import { SegmentTitleTextField } from "../../ContentBlocksEditor/children/ContentBlocksHeader/ContentBlocksHeader.styled";
import { ASSETS } from "../../../utils/config";
import EmojiPicker from "emoji-picker-react";
import { Close } from "@material-ui/icons";

const SegmentTitle = ({ onTitleChange, title }) => {
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);

  const emojiPickerRef = useRef(null);
  const emojiIconRef = useRef(null);

  const handleEmojiSelect = (emoji) => {
    // Get the current input element
    const input = document.getElementById("title-with-emoji");

    // Get the current text from the input
    const text = title;

    // Get the current cursor position
    const startPos = input.selectionStart;
    const endPos = input.selectionEnd;

    // Insert the emoji at the current cursor position
    const newText =
      title.length + emoji.length <= 75
        ? text.substring(0, startPos) +
          emoji +
          text.substring(endPos, text.length)
        : title;

    // Make sure to update the Formik field value as well
    onTitleChange(newText);

    // Set the cursor position right after the inserted emoji
    setTimeout(() => {
      input.selectionStart = input.selectionEnd = startPos + emoji.length;
    }, 0);
  };

  const handleTextChange = (event) => {
    const currentValue = event.target.value;
    const newValue = currentValue.length <= 75 ? currentValue : title;

    onTitleChange(newValue);
  };

  const handleOutsideClick = (event) => {
    if (
      emojiPickerRef.current &&
      !emojiPickerRef.current.contains(event.target) &&
      (!emojiIconRef.current || !emojiIconRef.current.contains(event.target))
    ) {
      setShowEmojiPicker(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <>
      <Stack gap={"10px"}>
        <SegmentSubTitle>Segment Title</SegmentSubTitle>

        <Stack gap={"5px"} direction={"row"} alignItems={"center"}>
          <SegmentTitleTextField
            autoFocus
            variant="standard"
            InputProps={{
              disableUnderline: true,
            }}
            placeholder="Add title here"
            value={title}
            name="title"
            id="title-with-emoji"
            onChange={handleTextChange}
            fullWidth
            fontWeightValue="500"
            fontSizeValue="14px"
            backgroundColor="#F6F7F9"
            multiline
            maxRows={2}
          />

          <SegmentTitleEmoji
            ref={emojiIconRef}
            src={ASSETS.emoji}
            onClick={() => {
              setShowEmojiPicker((prevState) => !prevState);
            }}
          />
        </Stack>
      </Stack>

      {showEmojiPicker ? (
        <Box
          ref={emojiPickerRef}
          style={{
            position: "fixed",
            transform: "translate(-50%, -50%)",
            top: "50vh",
            left: "10vw",
            display: "flex",
            flexDirection: "row",
            zIndex: 10000000,
          }}
        >
          <EmojiPicker
            onEmojiClick={(e) => handleEmojiSelect(e.emoji)}
            theme="light"
            autoFocusSearch={false}
          />
          <Box
            onClick={() => setShowEmojiPicker(false)}
            style={{
              // backgroundColor: "#123051",
              borderRadius: "12.5px",
              cursor: "pointer",
              position: "absolute",
              right: 15,
              top: 28,
              height: "25px",
              width: "25px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Close
              style={{
                fontSize: "25px",
                color: "#123051",
              }}
            />
          </Box>
        </Box>
      ) : null}
    </>
  );
};

export default SegmentTitle;
